import { useSelector } from 'react-redux';
import { useParams, Link } from 'react-router';
import Chevron from '../../components/chevron/Chevron';
import Image from '../../components/image/Image';
import MaxWidthWrapper from '../../components/max-width-wrapper/MaxWidthWrapper';
import { ContentTitle } from '../../components/typography/Heading';
import HeaderMenuContext from '../../context/header-menu-context';
import Main from '../../frame/main/Main';
import GenericHelmet from '../generic-helmet/GenericHelmet';
import TvaFindBosse from './TvaFindBosse';
import { useEffect } from 'react';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import styles from './project-tva-bosse-samleside.module.less';

const TvaFindBosseWrapper = () => {
    const { county, municipality, suburb, rl, hash, query } = useParams();
    const tvaEventId = useSelector((state) => state.campaigns?.tvaEventId);
    const p3aEventId = useSelector((state) => state.campaigns?.p3aEventId);

    useEffect(() => {
        trackPageView({
            urlAsEvent: 'tva-bosser',
            properties: { county, municipality, suburb, replacedLocation: rl, locationHash: hash, searchQuery: query },
        });
    }, [county, municipality, suburb, rl, hash, query]);

    return (
        <HeaderMenuContext.Provider value={{ showCreateButton: false }}>
            <Main>
                <GenericHelmet
                    title={'Digitale bøsser til NRK TV-aksjonen NRC Flyktninghjelpen 2026'}
                    description={'Finn din lokale bøsse!'}
                    imageUrl={'https://static.spleis.no/images/campaign/tva2026/coverbilde.webp'}
                >
                    <MaxWidthWrapper>
                        <div className={styles.headerContainer}>
                            <Link className={styles.backButton} to={'/tv-aksjonen'}>
                                <Chevron direction={'left'} className={styles.backIcon} />
                                Til TV-aksjonen
                            </Link>
                            <Image className={styles.tvaLogo} src={`campaign/tva2026/coverbilde.webp`} />
                            <ContentTitle tag={'h1'}>Finn en digital bøsse</ContentTitle>
                            <p className={styles.titleIntro}>
                                Søk opp ditt fylke, kommune, postnummer eller navn på innsamler for å gi
                            </p>
                        </div>
                    </MaxWidthWrapper>

                    <TvaFindBosse
                        queryCounty={county}
                        queryMunicipality={municipality}
                        querySuburb={suburb}
                        tvaEventId={tvaEventId}
                        p3aEventId={p3aEventId}
                    />
                </GenericHelmet>
            </Main>
        </HeaderMenuContext.Provider>
    );
};

export default TvaFindBosseWrapper;
